import React from 'react'
import LandingSection from "../components/LandingSection";
import Footer from "../components/Footer";

const PlacesLand = () => {
    const parks = [
        {
            "NAME": "Beartrap Canyon Wilderness",
            "MANAGEMENT AREA": "St. George Field Office",
            "Address": "Virgin, UT 84779, United States",
            "Phone No:": "435-688-3200",
            "Website": "https://www.blm.gov/visit/beartrap-canyon-wilderness",
            "Established on": "30 March 2009"
        },
        {
            "NAME": "Beaver Dam Mountains",
            "MANAGEMENT AREA": "St. George Field Office",
            "Address": "northwestern Arizona and southwestern Utah, USA",
            "Phone No:": "435-688-3200",
            "Website": "https://www.blm.gov/visit/beaver-dam-mountains-wilderness",
            "Established on": "28 August 1984"
        },
        {
            "NAME": "Black Ridge Canyons Wilderness",
            "MANAGEMENT AREA": "Moab Field Office",
            "Address": "Unnamed Road, Virgin, UT 84779, United States",
            "Phone No:": "970-244-3000",
            "Website": "https://www.blm.gov/visit/black-ridge-canyons-wilderness",
            "Established on": "30 March 2009"
        },
        {
            "NAME": "Black Ridge Wilderness",
            "MANAGEMENT AREA": "St. George Field Office",
            "Address": "Pine Valley, UT 84781, United States",
            "Phone No:": "435-259-2100",
            "Website": "https://www.blm.gov/visit/blackridge-wilderness",
            "Established on": "30 March 2009"
        },
        {
            "NAME": "Canaan Mountain Wilderness",
            "MANAGEMENT AREA": "St. George Field Office",
            "Address": "Apple Valley, UT 84737, United States",
            "Phone No:": "435-688-3200",
            "Website": "https://www.blm.gov/visit/canaan-mountain-wilderness",
            "Established on": "30 March 2009"
        },
        {
            "NAME": "Cedar Mountain Wilderness",
            "MANAGEMENT AREA": "Salt Lake Field Office",
            "Address": "Tooele County, Utah, USA",
            "Phone No:": "801-977-4300",
            "Website": "https://www.blm.gov/visit/cedar-mountain-wilderness-area",
            "Established on": "6 January 2006"
        },
        {
            "NAME": "Cottonwood Canyon Wilderness",
            "MANAGEMENT AREA": "St. George Field Office",
            "Address": "Washington County, Utah, USA",
            "Phone No:": "435-688-3200",
            "Website": "https://www.blm.gov/visit/cottonwood-canyon-wilderness",
            "Established on": "30 March 2009"
        },
        {
            "NAME": "Cougar Canyon Wilderness",
            "MANAGEMENT AREA": "St. George Field Office",
            "Address": "8597CXWX+3H, Utah, United States",
            "Phone No:": "435-688-3200",
            "Website": "https://www.blm.gov/visit/cougar-canyon-wilderness",
            "Established on": "30 March 2009"
        },
        {
            "NAME": "Deep Creek Wilderness",
            "MANAGEMENT AREA": "St. George Field Office",
            "Address": "Utah, United States",
            "Phone No:": "435-688-3200",
            "Website": "https://www.blm.gov/visit/deep-creek-wilderness",
            "Established on": "30 March 2009"
        },
        {
            "NAME": "Deep Creek North Wilderness",
            "MANAGEMENT AREA": "St. George Field Office",
            "Address": "Unnamed Road, Springdale, UT 84767, United States",
            "Phone No:": "435-688-3200",
            "Website": "https://www.blm.gov/visit/deep-creek-north-wilderness",
            "Established on": "30 March 2009"
        },
        {
            "NAME": "Doc's Pass Wilderness",
            "MANAGEMENT AREA": "St. George Field Office",
            "Address": "Gunlock, UT 84733, United States",
            "Phone No:": "435-688-3200",
            "Website": "https://www.blm.gov/visit/docs-pass-wilderness",
            "Established on": "30 March 2009"
        },
        {
            "NAME": "Goose Creek Wilderness",
            "MANAGEMENT AREA": "St. George Field Office",
            "Address": "Unnamed Road, Springdale, UT 84767, United States",
            "Phone No:": "435-688-3200",
            "Website": "https://www.blm.gov/visit/goose-creek-wilderness",
            "Established on": "30 March 2009"
        },
        {
            "NAME": "LaVerkin Creek Wilderness",
            "MANAGEMENT AREA": "St. George Field Office",
            "Address": "La Verkin Creek Trail, New Harmony, UT 84757, United States",
            "Phone No:": "435-688-3200",
            "Website": "https://www.blm.gov/visit/laverkin-creek-wilderness",
            "Established on": "30 March 2009"
        },
        {
            "NAME": "Red Butte Wilderness",
            "MANAGEMENT AREA": "St. George Field Office",
            "Address": "Washington County, Utah, USA",
            "Phone No:": "435-688-3200",
            "Website": "https://www.blm.gov/visit/red-butte-wilderness",
            "Established on": "30 March 2009"
        },
        {
            "NAME": "Red Mountain Wilderness",
            "MANAGEMENT AREA": "St. George Field Office",
            "Address": "18,700 acres N.W. of Snow Canyon State Park, Dammeron Valley, UT 84783, United States",
            "Phone No:": "435-688-3200",
            "Website": "https://www.blm.gov/visit/red-mountain-wilderness",
            "Established on": "30 March 2009"
        },
        {
            "NAME": "Slaughter Creek Wilderness",
            "MANAGEMENT AREA": "St. George Field Office",
            "Address": "Washington County, Utah, USA",
            "Phone No:": "435-688-3200",
            "Website": "https://www.blm.gov/visit/slaughter-creek-wilderness",
            "Established on": "30 March 2009"
        },
        {
            "NAME": "Taylor Creek Wilderness",
            "MANAGEMENT AREA": "St. George Field Office",
            "Address": "Lower Basin Rd, New Harmony, UT 84757, United States",
            "Phone No:": "435-688-3200",
            "Website": "https://www.blm.gov/visit/taylor-creek-wilderness",
            "Established on": "30 March 2009"
        },
        {
            "NAME": "Paria Canyon-Vermilion Cliffs",
            "MANAGEMENT AREA": "Arizona Strip Field Office",
            "Address": "Arizona Strip Field Office, 345 E. Riverside Drive, St. George, UT 84790",
            "Phone No:": "435-644-1200",
            "Website": "https://www.blm.gov/visit/paria-canyon-vermilion-cliffs-wilderness",
            "Established on": "28 August 1984"
        },
    ]
    return (
        <div className="min-h-screen flex flex-col bg-gradient-to-b from-blue-50 to-white">
            {/* Landing Section */}
            <LandingSection
                data={{ imageName: "land1.webp", title: "Bureau of Land Management Wilderness Areas" }}
            />

            {/* Main Content */}
            <div className=" mx-auto  py-12 w-full">
                {/* Intro Section */}
                <div className="text-center mb-12">
                    <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-blue-900 mb-2">
                        Utah's Bureau of Land Management Wilderness Areas
                    </h1>
                    <p className="text-xl text-blue-700">
                        Wander through vast, rugged BLM wilderness in Utah
                    </p>
                </div>

                {/* Parks Table */}
                <div className='flex items-center justify-center'>
                    <div className="bg-white rounded-xl  shadow-[0_4px_12px_0_rgba(1,76,178,0.3)] overflow-hidden w-[95%]">
                        <div className="overflow-x-auto">
                            <table className="min-w-full ">
                                <thead className="bg-gradient-to-r from-blue-50 to-blue-100">
                                    <tr>
                                        <th className="px-6 py-4 text-center text-[20px] font-bold text-blue-800 tracking-wider">
                                            Name
                                        </th>
                                        <th className="px-6 py-4 text-center text-[20px] font-bold text-blue-800 tracking-wider">
                                            Management Area
                                        </th>
                                        <th className="px-6 py-4 text-center text-[20px] font-bold text-blue-800 tracking-wider">
                                            Contact
                                        </th>
                                        <th className="px-6 py-4 text-center text-[20px] font-bold text-blue-800 tracking-wider">
                                            Website
                                        </th>
                                        <th className="px-6 py-4 text-center text-[20px] font-bold text-blue-800 tracking-wider">
                                            Established
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="bg-white">
                                    {parks.map((park, index) => (
                                        <tr key={index} className="hover:bg-blue-50 transition-colors">
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="text-sm text-center font-bold text-blue-900">{park.NAME}</div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="text-sm text-center font-bold text-blue-900">{park["MANAGEMENT AREA"]}</div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="text-sm text-center font-bold text-blue-900">{park["Phone No:"]}</div>
                                                <div className="text-sm text-center font-bold text-blue-900">{park.Address}</div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-center">
                                                <a
                                                    href={park.Website}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="text-blue-600 font-bold hover:text-blue-800 hover:underline"
                                                >
                                                    Visit Website
                                                </a>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-center font-bold text-blue-900">
                                                {park["Established on"]}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            {/* Footer */}
            <Footer />
        </div>
    )
}

export default PlacesLand
